export default __webpack_public_path__ + "static/light_purple_square.drawio-bff293413e959cad02f1f20668083303.png";